import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getUserNotification, updatePassword } from "../Common/apis";

const Setting = () => {
  const [activeTab2, setActiveTab2] = useState(1);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nData, setNData] = useState(null);

  const handleTabChange2 = (tabIndex) => {
    setActiveTab2(tabIndex);
  };
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  const getUserNoti = async () => {
    try {
      const response = await getUserNotification();
      setNData(response.data);
    } catch (error) {
      toast.error("Failed to fetch profile!");
    }
  };

  useEffect(() => {
    getUserNoti();
  }, []);

  const handlePasswordUpdate = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }
    if (currentPassword === newPassword) {
      toast.error("New password cannot be same as current password");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New passwords do not match");
      return;
    }

    try {
      const res = await updatePassword({
        currentPassword,
        newPassword
      });

      if (res) {
        toast.success("Password updated successfully");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update password");
    }
  };
  return (
    <>
      <div className="profile-info overflow-hidden">
        <div className="profile-info-heading">
          <h3 data-aos="fade-right">Settings</h3>
        </div>
        <p
          data-aos="fade-left"
          className="font-[400] font-sans text-[16px] text-[#000000] pt-[6px] pb-[20px] leading-[27px]"
        >
          You have full control to manage your own account settings
        </p>
        <div className="setting-tab">
          <button
            data-aos="flip-up"
            className={activeTab2 === 1 ? "tab-btn-s active" : "tab-btn-s"}
            onClick={() => handleTabChange2(1)}
          >
            Change Password
          </button>
          {/* <button
            data-aos="flip-up"
            className={activeTab2 === 2 ? "tab-btn-s active" : "tab-btn-s"}
            onClick={() => handleTabChange2(2)}
          >
            Social Profiles
          </button>
          <button
            data-aos="flip-up"
            className={activeTab2 === 3 ? "tab-btn-s active" : "tab-btn-s"}
            onClick={() => handleTabChange2(3)}
          >
            Linked Accounts
          </button>*/}
          <button
            data-aos="flip-up"
            className={activeTab2 === 4 ? "tab-btn-s active" : "tab-btn-s"}
            onClick={() => {
              handleTabChange2(4);
            }}
          >
            Notifications
          </button>
        </div>
        {activeTab2 === 1 && (
          <>
            <div className="profile-info-ips pt-[30px]">
              <div className="profile-info-ip">
                <label data-aos="fade-right">Current Password</label>
                <input
                  data-aos="fade-left"
                  type="password"
                  placeholder="Enter current password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
              <div className="profile-info-ip">
                <label data-aos="fade-right">New Password</label>
                <input
                  data-aos="fade-left"
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
            </div>
            <br />
            <div className="profile-info-ips">
              <div className="profile-info-ip">
                <label data-aos="fade-right">Confirm New Password</label>
                <input
                  data-aos="fade-left"
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
            <button
              onClick={handlePasswordUpdate}
              className="UpdatePassword font-sans mt-[30px] text-[17px] text-[#263238]"
            >
              Update Password
            </button>
          </>
        )}
      </div>
      {activeTab2 === 4 && (
        <>
          <div className="flex flex-col items-start justify-center">
            {nData?.map((item, index) => {
              return (
                <>
                  <div key={index} className="flex justify-between items-center w-full bg-[#EDEDED] rounded-[10px] p-[20px] mt-[20px] gap-[20px]">
                    <div>
                      <h6 className="font-[600] font-poppins md:text-[20px] text-[16px] text-[#000000]">
                        {item.title}
                      </h6>
                      <p className="font-[400] font-sans md:text-[16px] pt-[10px] text-[14px] text-[#000000]">
                        {item?.message}
                      </p>
                    </div>
                    <button onClick={() => {
                      setSelectedNotification(item);
                      setIsModalOpen1(true);
                    }}
                      className="px-[32px] py-[16px] font-poppins rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white">Show Notification</button>
                  </div>
                </>
              )
            })}
          </div>
          {isModalOpen1 && selectedNotification && (
            <NotificationModal
              isOpen={isModalOpen1}
              title={selectedNotification.title}
              message={selectedNotification.message}
              onClose={() => setIsModalOpen1(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default Setting;

const NotificationModal = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h6 className="font-[700] font-sans md:text-[40px] text-[26px] text-center leading-[-0.32px] text-[#6953A3]">
          {title}
        </h6>
        <div className="flex md:pt-[27px] pt-[7px] md:pb-[37px] pb-[22px] items-center justify-center">
          <img
            src="/assets/slider/img6.png"
            className="md:h-[173px] h-[150px] md:w-[173px] w-[150px]"
            alt=""
          />
        </div>
        <div className="flex flex-col items-center md:gap-[14px] gap-0">
          <h6 className="font-[700] font-sans md:text-[20px] text-[16px] md:pb-[28px] pb-[25px] text-center leading-[-0.32px] text-[#6953A3]">
            {message}
          </h6>
        </div>
        {/* <div className="flex flex-col gap-[16px] md:px-[26px] px-0">
          <button className="py-[14px] text-center w-full rounded-[10px] bg-[#F1E60D] font-sans font-[400] text-[16px] text-[#263238]">
            Subscribe Now
          </button>
          <button className="py-[14px] text-center w-full rounded-[10px] bg-[#6953A3] font-sans font-[400] text-[16px] text-[#FFFFFF]">
            Not Now
          </button>
        </div> */}
      </div>
    </div>
  );
};
